jQuery(function($) {
  // Filter toggle functionality
  function closeFilter() {
    $('#filter-wrap, #list-filter').toggleClass('closed');
  }

  $('#filter-toggle').click(function() {
    closeFilter();
  });

  $('#JS-filter-btn-dynamic').click(function() {
    closeFilter();
  });

  $('.filter label').keypress(function(e) {
    if (e.keyCode === 32) {
      $('[id="' + $(this).attr('for') + '"]').click();
      $(this).focus();
      e.preventDefault();
    }
  });

  // Close filter modal initially on mobile
  if ($(window).width() <= 1100) {
    closeFilter();
  }

  if (!$('.listing-article-item')[0]) {
    $('#top-results-uber .listing-article-results').addClass('empty');
  }

  if ($('#top-results').length && $('#top-results').width() < 780) {
    $('#top-results').addClass('compressed');
  }

  //Uber specific
  if ($('#top-results-uber').length && $('#top-results-uber').width() < 561) {
    $('#top-results-uber').addClass('compressed');
  }
});
